export default __webpack_public_path__ + "static/media/icon-mind.e4e49487.svg";